import cn from "classnames";

import { commonBlocksOptions } from "@components/cmsBlocks/configs";
import Editor from "@ui-kit/cms/Editor/Editor";

import s from "./BlockTitle.module.scss";

const BlockTitle = ({ className, field, type, onChange, settings }) => {
  const { options } = commonBlocksOptions.blockType;
  let Component = null;

  const hasCustomColor = settings?.common?.titleColor?.value;

  // options.some((option, key) => {
  //   // console.log("type", type);
  //   if (type.value === options[0].value) {
  //     Component = "h2";
  //     return true;
  //   }

  //   if (type.value === options[1].value) {
  //     Component = "h3";
  //     return true;
  //   }

  //   if (key >= 2) {
  //     Component = null;
  //     return true;
  //   }
  // });

  // console.log("Component", Component);

  switch (type.value) {
    case options[0].value:
      Component = "h2";
      break;
    case options[1].value:
      Component = "h3";
      break;
    case options[2].value:
      Component = null;
      break;
    case options[3].value:
      Component = null;
      break;
    case options[4].value:
      Component = null;
      break;
    case options[5].value:
      Component = null;
      break;
    default:
      Component = null;
      break;
  }

  const styles = {
    ...(hasCustomColor && { color: `#${hasCustomColor}` }),
  };

  return Component ? (
    <Component className={cn(s.title, s[type.value], className)} style={styles}>
      <Editor field={field} onChange={onChange} onlyText />
    </Component>
  ) : null;
};

export default BlockTitle;
